// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2MH_w","title":"Images90_title__iw-rM","images":"Images90_images__2Jtph"};